import ChildAPI from "../api/child";

export const children = {
    state: {
        children: [],
        childOptions:{
            lineCount:0,
            showDeleted:false,
            orderBy:'surname',
            orderDirection:'asc',
            itemsPerPage:10,
            itemAdded:false,
            itemSearched:false,
            selectedYear:0,
            selectedCourse:0,
            showWithoutCourse:false
        },
        childOptionsInCourse:{
            lineCount:0,
            showDeleted:false,
            orderBy:'surname',
            orderDirection:'asc',
            itemsPerPage:10,
            itemAdded:false,
            itemSearched:false,
            selectedYear:0,
            selectedCourse:0,
            showWithoutCourse:false
        },
        childLogOptions:{
            lineCount:0,
            itemsPerPage:10,
            fromDate:'2020-06-01',
            toDate:'2020-06-30'
        },
        childPresenceOptions:{
            lineCount:0,
            itemsPerPage:10,
            fromDate:'2020-06-01',
            toDate:'2020-06-30'
        },
        childSettlementsOptions:{
            lineCount:0,
            itemsPerPage:10,
            fromDate:'2019-06',
            toDate:'2020-06'
        },
        childrenLoadStatus: 0,
        childAddStatus: 0,
        childAddText: "",

        childEdit: {
            id: 0,
            lp: 0,
            name: '',
            surname:'',
            birth_year:'',
            note:'',
            pickup:false,
            course_id:''
        },
        childEditDefault: {
            id: 0,
            lp: 0,
            name: '',
            surname:'',
            birth_year:'',
            note:'',
            pickup:false,
            course_id:''
        },
        childEditLoadStatus: 0,
        childEditStatus: 0,
        childEditText: "",

        childDeleteStatus: 0,
        childDeleteText: "",

        //####################################
        child:{name:'',surname:'',owners:[],references:[]},
        childLoadStatus: 0,
        childSearchStatus: 0,
        childSearchData: '',
        childLog:{logs:[]},
        childLogLoadStatus: 0,
        childPresence:{presences:[]},
        childPresenceLoadStatus: 0,
        childSettlements:{settlements:[]},
        childSettlementsLoadStatus: 0,
        childSelectedYear:0,

        childRateEdit: {
            id: 0,
            child_id: '',
            rate_id:'',
            document:'',
            expiry:'',
            valid_from:undefined
        },
        childRateEditDefault: {
            id: 0,
            child_id: '',
            rate_id:'',
            document:'',
            expiry:'',
            valid_from:undefined
        },
        childRateEditText:'',
        childRateEditStatus:0,
        childRateEditLoadStatus:0,
        childrenLookupLoadStatus:0,
        childrenLookup:[],

        //########################
        childrenShortCard:[],
        childrenShortCardLoadStatus:0,
    },

    actions: {
        loadMyChildren({ state, commit, dispatch }) {
            commit("setChildren", []);
            commit("setChildrenLoadStatus", 1);
                ChildAPI.getMyChildren()
                .then(function(response) {
                    commit("setChildren", response.data);
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        loadChildren({ state, commit, dispatch }) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.getChildren({
                    offset:0,
                    itemsPerPage:state.childOptions.itemsPerPage, 
                    orderBy:state.childOptions.orderBy,
                    orderDirection:state.childOptions.orderDirection,
                    showDeleted:state.childOptions.showDeleted,
                    selectedYear:state.childOptions.selectedYear,
                    selectedCourse:state.childOptions.selectedCourse,
                    showWithoutCourse:state.childOptions.showWithoutCourse
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setChildLineCount", response.data.lineCount);
                    commit("setChildren", response.data.children);
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        loadMoreChildren({ state, commit, dispatch }) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.getChildren({
                    offset:state.children.length,
                    itemsPerPage:state.childOptions.itemsPerPage, 
                    orderBy:state.childOptions.orderBy,
                    orderDirection:state.childOptions.orderDirection,
                    showDeleted:state.childOptions.showDeleted,
                    selectedYear:state.childOptions.selectedYear,
                    selectedCourse:state.childOptions.selectedCourse,
                    showWithoutCourse:state.childOptions.showWithoutCourse
                })
                .then(function(response) {
                    commit("setChildLineCount", response.data.lineCount);
                    commit("setChildren", _.concat(state.children, response.data.children));
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        searchChildren({ state, commit, dispatch },data) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.searchChildren({
                    showDeleted:state.childOptions.showDeleted,
                    selectedYear:state.childOptions.selectedYear,
                    selectedCourse:state.childOptions.selectedCourse,
                    showWithoutCourse:state.childOptions.showWithoutCourse,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setChildSearchedTrue");
                    commit("setChildLineCount", response.data.lineCount);
                    commit("setChildren", response.data.children);
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        setChildOptions({ state, commit, dispatch },data){
            commit("setChildOptions",data.options);
            dispatch("loadChildren");
        },
        loadChildrenInCourse({ state, commit, dispatch }) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.getChildren({
                    offset:0,
                    itemsPerPage:state.childOptionsInCourse.itemsPerPage, 
                    orderBy:state.childOptionsInCourse.orderBy,
                    orderDirection:state.childOptionsInCourse.orderDirection,
                    showDeleted:state.childOptionsInCourse.showDeleted,
                    selectedYear:state.childOptionsInCourse.selectedYear,
                    selectedCourse:state.childOptionsInCourse.selectedCourse,
                    showWithoutCourse:state.childOptionsInCourse.showWithoutCourse
                })
                .then(function(response) {
                    commit("setOptionsInCourseItemAddedAndSearchedFalse");
                    commit("setChildInCourseLineCount", response.data.lineCount);
                    commit("setChildren", response.data.children);
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        loadMoreChildrenInCourse({ state, commit, dispatch }) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.getChildren({
                    offset:state.children.length,
                    itemsPerPage:state.childOptionsInCourse.itemsPerPage, 
                    orderBy:state.childOptionsInCourse.orderBy,
                    orderDirection:state.childOptionsInCourse.orderDirection,
                    showDeleted:state.childOptionsInCourse.showDeleted,
                    selectedYear:state.childOptionsInCourse.selectedYear,
                    selectedCourse:state.childOptionsInCourse.selectedCourse,
                    showWithoutCourse:state.childOptionsInCourse.showWithoutCourse
                })
                .then(function(response) {
                    commit("setChildInCourseLineCount", response.data.lineCount);
                    commit("setChildren", _.concat(state.children, response.data.children));
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        searchChildrenInCourse({ state, commit, dispatch },data) {
            commit("setChildrenLoadStatus", 1);
                ChildAPI.searchChildren({
                    showDeleted:state.childOptionsInCourse.showDeleted,
                    selectedYear:state.childOptionsInCourse.selectedYear,
                    selectedCourse:state.childOptionsInCourse.selectedCourse,
                    showWithoutCourse:state.childOptionsInCourse.showWithoutCourse,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsInCourseItemAddedAndSearchedFalse");
                    commit("setChildInCourseSearchedTrue");
                    commit("setChildInCourseLineCount", response.data.lineCount);
                    commit("setChildren", response.data.children);
                    dispatch("applyIndexOnChildren");
                    commit("setChildrenLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildren", []);
                    commit("setChildrenLoadStatus", 3);
                });
         
        },
        setChildOptionsInCourse({ state, commit, dispatch },data){
            commit("setChildOptionsInCourse",data.options);
            dispatch("loadChildrenInCourse");
        },
        applyIndexOnChildren({ commit, state, rootState }) {
            let localChildren = state.children;

            var i = 1;
            localChildren.forEach(child => {
                if(_.isArray(child.owners)){
                    child.owners = _.map(child.owners,u=>u.name + ' ' + u.mobile).join('<br>')
                }
                if(_.isArray(child.courses)){
                    child.courses = child.courses[0];
                }
                child.lp = i;
                i++;
            });

            commit("setChildren",localChildren);
        },
        addChild({ commit, state, dispatch }, data) {
            commit("setChildAddStatus", 1);
            commit("setChildAddText", "");

            ChildAPI.postAddNewChild(
                data.name,
                data.surname,
                data.birth_year,
                data.note,
                data.pickup,
                data.year_id,
                data.course_id
            )
                .then(function(response) {
                    commit("setChildAddStatus", 2);
                    commit("setAddedChild",response.data);
                    commit("setChildLineCount", state.childOptions.lineCount + 1);
                    dispatch("applyIndexOnChildren");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadChildLookup");
                })
                .catch(function(error) {
                    commit("setChildAddStatus", 3);
                    commit("setChildAddText", error.response.data.errors);
                });
        },
        importChildren({ commit, state, dispatch }, data) {
            commit("setChildAddStatus", 1);
            commit("setChildAddText", "");

            ChildAPI.postImportChildren(
                data.children,
            )
                .then(function(response) {
                    commit("setChildAddStatus", 2);
                    dispatch("loadChildren");
                })
                .catch(function(error) {
                    commit("setChildAddStatus", 3);
                    commit("setChildAddText", error.response.data.errors);
                });
        },

        loadChildEdit({ commit }, data) {
            commit("setChildEditLoadStatus", 1);
            commit("setChildEditStatus", 0);
            commit("setChildEditText", "");

            ChildAPI.getChildEdit(data.slug,data.year_id)
                .then(function(response) {
                    commit("setChildEdit", response.data);
                    commit("setChildEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildEdit", {});
                    commit("setChildEditLoadStatus", 3);
                });
        },
        loadChildEditDefault({ commit }) {
            commit("setChildEditDefault");
        },
        loadChildAddDefault({ commit }) {
            commit("setChildAddStatus", 0);
            commit("setChildAddText", "");
        },
        editChild({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putEditChild(
                data.slug,
                data.name,
                data.surname,
                data.birth_year,
                data.note,
                data.pickup,
                data.year_id,
                data.course_id
            )
                .then(function(response) {
           
                    commit("setChildEditStatus", 2);
                    commit("setEditedChild",response.data)
                    dispatch("applyIndexOnChildren");
                    //dispatch("loadChildLookup");
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildEditText", error.response.data.errors);
                });
        },
        editChildReactivate({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);
  
            ChildAPI.putReactivateChild(data.slug,data.year_id)
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    commit("setEditedChild",response.data)
                    dispatch("applyIndexOnChildren");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadChildLookup");
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                });
        },
        deleteChild({ commit, state, dispatch }, data) {
            commit("setChildDeleteStatus", 1);

            ChildAPI.deleteChild(data.slug,data.year_id)
                .then(function(response) {
                    commit("setChildDeleteStatus", 2);
                    if(state.childOptions.showDeleted){
                        commit("setEditedChild",response.data)
                    }else{
                        commit("setChildLineCount", state.childOptions.lineCount - 1);
                        commit("setDeletedChild",response.data)
                    }
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadChildLookup");
                    dispatch("applyIndexOnChildren");
                })
                .catch(function() {
                    commit("setChildDeleteStatus", 3);
                });
        },
        forceDeleteChild({ commit, state, dispatch }, data) {
            commit("setChildDeleteStatus", 1);

            ChildAPI.forceDeleteChild(data.slug,data.year_id)
                .then(function(response) {
                    commit("setChildDeleteStatus", 2);
                    commit("setChildLineCount", state.childOptions.lineCount - 1);
                    commit("setDeletedChild",response.data)
                    dispatch("applyIndexOnChildren");
                })
                .catch(function() {
                    commit("setChildDeleteStatus", 3);
                });
        },
        //################################################
        loadChildMobile({ commit, dispatch, state }, data) {
            commit("setChild", {name:'',surname:'',owners:[]});
            commit("setChildLoadStatus", 1);
            ChildAPI.getChildMobile(data.slug)
                .then(function(response) {
                    commit("setChild", response.data);
                    //dispatch("applyIndexOnChild");
                    commit("setChildLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChild", {});
                    commit("setChildLoadStatus", 3);
                });
        },
        loadChild({ commit, dispatch, state }, data) {
            commit("setChild", {name:'',surname:'',owners:[],references:[]});
            commit("setChildLoadStatus", 1);
            if(data.year_id){
                commit("setChildSelectedYear",data.year_id);
            }
            ChildAPI.getChild(data.slug,state.childSelectedYear)
                .then(function(response) {
                    commit("setChild", response.data);
                    dispatch("applyIndexOnChild");
                    commit("setChildLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChild", {});
                    commit("setChildLoadStatus", 3);
                });
        },
        loadChildrenByCard({ commit, dispatch, state }, data) {
            commit("setChild", {name:'',surname:'',owners:[]});
            commit("setChildSearchStatus", 1);
            if(data.year_id){
                commit("setChildSelectedYear",data.year_id);
            }
            ChildAPI.getChildrenByCard(data.card,state.childSelectedYear)
                .then(function(response) {
                    commit("setChild", response.data);
                    commit("setChildSearchData", data.card);
                    //dispatch("applyIndexOnChild");
                    commit("setChildSearchStatus", 2);
                })
                .catch(function() {
                    commit("setChild", {});
                    commit("setChildSearchStatus", 3);
                });
        },
        loadChildOwner({ commit, dispatch, state }, data) {
            commit("setChild", {});
            commit("setChildLoadStatus", 1);
            ChildAPI.getChildOwner(data.slug)
                .then(function(response) {
                    commit("setChild", {owners:response.data});
                    //dispatch("applyIndexOnChild");
                    commit("setChildLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChild", {});
                    commit("setChildLoadStatus", 3);
                });
        },
        applyIndexOnChild({ commit, state, rootState }) {
            let localChild = state.child;
            
            var i = 1;
            localChild.owners.forEach(u => {
                if(_.isNumber(u.role)){
                    u.role = _.find(rootState.lookups.roles, { 'value': u.role }).text;
                }
                u.lp = i;
                i++;
            });

            i = 1;
            localChild.references.forEach(u => {
                if(_.isArray(u.last_settlement) && u.last_settlement.length>0){
                    u.last_settlement = u.last_settlement[0];
                    if(_.isArray(u.last_settlement.documents)){
                        u.last_settlement.documents = _.map(u.last_settlement.documents,d=>d.document_number).join(', ');
                    }
                }else{
                    u.last_settlement = undefined;
                }
                
                u.lp = i;
                i++;
            });

            commit("setChild",localChild);
        },
        editChildCourse({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putNewCourse(
                data.slug,
                data.course_id
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildEditText", error.response.data.errors);
                });
        },
        loadChildRateEdit({ commit, state }, data) {
            commit("setChildRateEditLoadStatus", 1);
            commit("setChildRateEditText", "");

            ChildAPI.getEditRateData(data.slug,state.childSelectedYear)
                .then(function(response) {
                    commit("setChildRateEdit", response.data);
                    commit("setChildRateEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildEdit", {});
                    commit("setChildRateEditLoadStatus", 3);
                });
        },
        loadChildRateEditDefault({ commit }) {
            commit("setChildRateEditDefault");
        },
        editChildRate({ commit, state, dispatch }, data) {
            commit("setChildRateEditStatus", 1);

            ChildAPI.putEditRate(
                data.slug,
                data.rate_id,
                data.document,
                data.expiry,
                data.valid_from
            )
                .then(function(response) {
                    commit("setChildRateEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildRateEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        searchChildrenLookup({ state, commit, dispatch },data) {
            commit("setChildrenLookupLoadStatus", 1);
                ChildAPI.searchChildrenLookup({
                    slug:data.slug,
                    q:data.q
                })
                .then(function(response) {
                    commit("setChildrenLookup", response.data);
                    commit("setChildrenLookupLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildrenLookup", []);
                    commit("setChildrenLookupLoadStatus", 3);
                });
         
        },
        searchChildrenLookupSW({ state, commit, dispatch },data) {
            commit("setChildrenLookupLoadStatus", 1);
                ChildAPI.searchChildrenLookupSW({
                    q:data.q
                })
                .then(function(response) {
                    commit("setChildrenLookup", response.data);
                    commit("setChildrenLookupLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildrenLookup", []);
                    commit("setChildrenLookupLoadStatus", 3);
                });
         
        },
        searchChildrenSettlementLookup({ state, commit, dispatch },data) {
            commit("setChildrenLookupLoadStatus", 1);
                ChildAPI.searchChildrenSettlementLookup({
                    selectedYear:data.selectedYear,
                    selectedMonth:data.selectedMonth,
                    q:data.q
                })
                .then(function(response) {
                    commit("setChildrenLookup", response.data);
                    commit("setChildrenLookupLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildrenLookup", []);
                    commit("setChildrenLookupLoadStatus", 3);
                });
         
        },
        childrenAddReference({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putAddRerefence(
                data.slug,
                data.child_id
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        childrenDeleteReference({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putDeleteRerefence(
                data.slug,
                data.child_id
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        childrenAddNote({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putAddNote(
                data.slug,
                data.note
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        childrenAddDietNote({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putAddDietNote(
                data.slug,
                data.diet,
                data.diet_note
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        childrenAddImage({ commit, state, dispatch }, data) {
            commit("setChildEditStatus", 1);

            ChildAPI.putAddImage(
                data.slug,
                data.input_img
            )
                .then(function(response) {
                    commit("setChildEditStatus", 2);
                    dispatch("loadChild",{slug:response.data});
                })
                .catch(function(error) {
                    commit("setChildEditStatus", 3);
                    commit("setChildRateEditText", error.response.data.errors);
                });
        },
        setChildLogOptions({ state, commit, dispatch },data){
            commit("setChildLogOptions",data.options);
            dispatch("loadChildLog");
        },
        loadChildLog({ commit, dispatch, state }, data) {
            commit("setChildLogLoadStatus", 1);
            ChildAPI.getChildLog({
                    slug:state.child.id,
                    fromDate:state.childLogOptions.fromDate,
                    toDate:state.childLogOptions.toDate
            })
                .then(function(response) {
                    commit("setChildLog", response.data);
                    dispatch("applyIndexOnChildLog");
                    commit("setChildLogLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildLog", {});
                    commit("setChildLogLoadStatus", 3);
                });
        },
        applyIndexOnChildLog({ commit, state, rootState }) {
            let localChildLog = state.childLog;
            
            //var i = 1;
            localChildLog.logs.forEach(u => {
                if(_.isNumber(u.action)){
                    u.action = _.find(rootState.lookups.childlog, { 'value': u.action }).text;
                }
                if(u.param && u.param!=''){
                    if(u.param=="owner.role"){
                        u.before = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.before) }).text;
                        u.after = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.after) }).text;
                    }
                    u.param = _.find(rootState.lookups.childLogParams, { 'value': u.param }).text;
                }
                //u.lp = i;
                //i++;
            });

            commit("setChildLog",localChildLog);
        },
        setChildPresenceOptions({ state, commit, dispatch },data){
            commit("setChildPresenceOptions",data.options);
            dispatch("loadChildPresence");
        },
        loadChildPresence({ commit, dispatch, state }, data) {
            commit("setChildPresenceLoadStatus", 1);
            ChildAPI.getChildPresence({
                    slug:state.child.id,
                    fromDate:state.childPresenceOptions.fromDate,
                    toDate:state.childPresenceOptions.toDate
            })
                .then(function(response) {
                    commit("setChildPresence", response.data);
                    dispatch("applyIndexOnChildPresence");
                    commit("setChildPresenceLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildPresence", {});
                    commit("setChildPresenceLoadStatus", 3);
                });
        },
        applyIndexOnChildPresence({ commit, state, rootState }) {
            let localChildPresence = state.childPresence;
            
            //var i = 1;
            localChildPresence.presences.forEach(u => {
                // if(_.isArray(u.courses)){
                //     u.courses = u.courses[0];
                // }
                // if(_.isNumber(u.action)){
                //     u.action = _.find(rootState.lookups.childlog, { 'value': u.action }).text;
                // }
                // if(u.param && u.param!=''){
                //     if(u.param=="owner.role"){
                //         u.before = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.before) }).text;
                //         u.after = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.after) }).text;
                //     }
                //     u.param = _.find(rootState.lookups.childPresenceParams, { 'value': u.param }).text;
                // }
                //u.lp = i;
                //i++;
            });

            commit("setChildPresence",localChildPresence);
        },
        setChildSettlementsOptions({ state, commit, dispatch },data){
            commit("setChildSettlementsOptions",data.options);
            dispatch("loadChildSettlements");
        },
        loadChildSettlements({ commit, dispatch, state }, data) {
            commit("setChildSettlementsLoadStatus", 1);
            ChildAPI.getChildSettlements({
                    slug:state.child.id,
                    fromDate:state.childSettlementsOptions.fromDate,
                    toDate:state.childSettlementsOptions.toDate
            })
                .then(function(response) {
                    commit("setChildSettlements", response.data);
                    //dispatch("applyIndexOnChildSettlements");
                    commit("setChildSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildSettlements", {});
                    commit("setChildSettlementsLoadStatus", 3);
                });
        },
        applyIndexOnChildSettlements({ commit, state, rootState }) {
            let localChildSettlements = state.childSettlements;
            
            //var i = 1;
            localChildSettlements.presences.forEach(u => {
                // if(_.isArray(u.courses)){
                //     u.courses = u.courses[0];
                // }
                // if(_.isNumber(u.action)){
                //     u.action = _.find(rootState.lookups.childlog, { 'value': u.action }).text;
                // }
                // if(u.param && u.param!=''){
                //     if(u.param=="owner.role"){
                //         u.before = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.before) }).text;
                //         u.after = _.find(rootState.lookups.roles, { 'value': _.toNumber(u.after) }).text;
                //     }
                //     u.param = _.find(rootState.lookups.childSettlementsParams, { 'value': u.param }).text;
                // }
                //u.lp = i;
                //i++;
            });

            commit("setChildSettlements",localChildSettlements);
        },

        //###########################

        loadChildrenShortCard({ state, commit, dispatch }) {
            commit("setChildrenShortCardLoadStatus", 1);
                ChildAPI.getChildrenShortCard()
                .then(function(response) {
                    commit("setChildrenShortCard", response.data);
                    dispatch("applyIndexOnChildrenShortCard");
                    commit("setChildrenShortCardLoadStatus", 2);
                })
                .catch(function() {
                    commit("setChildrenShortCard", []);
                    commit("setChildrenShortCardLoadStatus", 3);
                });
         
        },
        applyIndexOnChildrenShortCard({ commit, state }) {
            let localChildrenShortCard = state.childrenShortCard;

            var i = 1;
            localChildrenShortCard.forEach(u => {
                if(_.isArray(u.courses)){
                    u.course = _.head(u.courses);
                }
                if(_.isArray(u.rates_with_short_card)){
                    u.rates_with_short_card = _.head(u.rates_with_short_card);
                }
                u.lp = i;
                i++;
            });

            commit("setChildrenShortCard",localChildrenShortCard);
        },
    },
    mutations: {
        setChildOptions(state,options){
            state.childOptions = options;
            state.childEdit.year_id = options.selectedYear;
            state.childEditDefault.year_id = options.selectedYear;
        },
        setChildOptionsInCourse(state,options){
            state.childOptionsInCourse = options;
            //state.childEdit.year_id = options.selectedYear;
            //state.childEditDefault.year_id = options.selectedYear;
        },
        setChildrenLoadStatus(state, status) {
            state.childrenLoadStatus = status;
        },
        setChildren(state, children) {
            state.children = children;
        },
        setChildLineCount(state, lineCount) {
            state.childOptions.lineCount = lineCount;
        },
        setChildInCourseLineCount(state, lineCount) {
            state.childOptionsInCourse.lineCount = lineCount;
        },
        setChildAddStatus(state, status) {
            state.childAddStatus = status;
        },
        setChildAddText(state, text) {
            state.childAddText = text;
        },
        setChildEdit(state, child) {
            //pobiera dane do edycji
            state.childEdit = child;

        },
        setEditedChild(state, child) {
            var lp = _.find(state.children,{'id':child.id}).lp;
            var index = _.findIndex(state.children,{'id':child.id});
           
            state.children[index] = child;
            state.children[index].lp = lp;
        },
        setAddedChild(state, child) {
           
            state.childOptions.itemAdded = true;
            state.children.push(child);
        },
        setChildSearchedTrue(state) {
            state.childOptions.itemSearched = true;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.childOptions.itemAdded = false;
            state.childOptions.itemSearched = false;
        },
        setChildInCourseSearchedTrue(state) {
            state.childOptionsInCourse.itemSearched = true;
        },
        setOptionsInCourseItemAddedAndSearchedFalse(state) {
            state.childOptionsInCourse.itemAdded = false;
            state.childOptionsInCourse.itemSearched = false;
        },
        setDeletedChild(state, child) {
            var index = _.findIndex(state.children,{'id':child.id});
            state.children.splice(index,1);
        },
        setChildEditDefault(state) {
            state.childEdit = { ...state.childEditDefault };
        },
        setChildEditStatus(state, status) {
            state.childEditStatus = status;
        },
        setChildEditText(state, text) {
            state.childEditText = text;
        },
        setChildEditLoadStatus(state, status) {
            state.childEditLoadStatus = status;
        },
        setChildDeleteStatus(state, status) {
            state.childDeleteStatus = status;
        },
        setChildDeletedText(state, text) {
            state.childDeleteText = text;
        },
        //##########################################
        setChildLoadStatus(state, status) {
            state.childLoadStatus = status;
        },
        setChildSearchStatus(state, status) {
            state.childSearchStatus = status;
        },
        setChildSearchData(state,data){
            state.childSearchData = data;
        },
        setChild(state, child) {
            state.child = child;
            state.child.noteOrig = child.note;
            state.child.noteDietOrig = child.diet_note;
            state.child.dietOrig = child.diet;
        },
        setFirstChild(state) {
            state.child = state.child[0];
        },
        setChildSelectedYear(state, year) {
            state.childSelectedYear = year;
        },
        setChildRateEdit(state, child) {
            //pobiera dane do edycji
            state.childRateEdit = child;

        },
        setChildRateEditDefault(state) {
            state.childRateEdit = { ...state.childRateEditDefault };
        },
        setChildRateEditStatus(state, status) {
            state.childRateEditStatus = status;
        },
        setChildRateEditText(state, text) {
            state.childRateEditText = text;
        },
        setChildRateEditLoadStatus(state, status) {
            state.childRateEditLoadStatus = status;
        },
        setChildrenLookupLoadStatus(state, status) {
            state.childrenLookupLoadStatus = status;
        },
        setChildrenLookup(state, lookup) {
            state.childrenLookup = lookup;
        },
        //logs
        setChildLogLoadStatus(state, status) {
            state.childLogLoadStatus = status;
        },
        setChildLog(state, child) {
            state.childLog = child;
        },
        setChildLogOptions(state,options){
            state.childLogOptions = options;
        },
        //presences
        setChildPresenceLoadStatus(state, status) {
            state.childPresenceLoadStatus = status;
        },
        setChildPresence(state, child) {
            state.childPresence = child;
        },
        setChildPresenceOptions(state,options){
            state.childPresenceOptions = options;
        },
         //settlements
         setChildSettlementsLoadStatus(state, status) {
            state.childSettlementsLoadStatus = status;
        },
        setChildSettlements(state, child) {
            state.childSettlements = child;
        },
        setChildSettlementsOptions(state,options){
            state.childSettlementsOptions = options;
        },

        //short card
        setChildrenShortCard(state,data){
            state.childrenShortCard = data;
        },
        setChildrenShortCardLoadStatus(state,status){
            state.childrenShortCardLoadStatus = status;
        }
    },

    getters: {
        getChildOptions(state){
            return state.childOptions;
        },
        getChildOptionsInCourse(state){
            return state.childOptionsInCourse;
        },
        getChildrenLoadStatus(state) {
            return state.childrenLoadStatus;
        },
        getChildren(state) {
            return state.children;
        },
        getChildAddStatus(state) {
            return function(){
                return state.childAddStatus;
            } 
        },
        getChildAddText(state) {
            return state.childAddText;
        },
        getChildEdit(state) {
            return state.childEdit;
        },
        getChildEditStatus(state) {
          return function(){
            return state.childEditStatus;
          }
        },
        getChildEditing(state) {
            return state.childEdit.id > 0;
        },
        getChildEditText(state) {
            return state.childEditText;
        },
        getChildEditLoadStatus(state) {
            return state.childEditLoadStatus;
            
        },
        getChildDeleteStatus(state) {
            return function(){
                return state.childDeleteStatus;
            }
        },
        getChildDeleteText(state) {
            return state.childDeleteText;
        },
        //######################################
        getChildLoadStatus(state) {
            return state.childLoadStatus;
        },
        getChildSearchStatus(state) {
            return function(){
                return state.childSearchStatus;
            }
        },
        getChildSearchData(state) {
            return state.childSearchData;
        },
        getChild(state) {
            return state.child;
        },
        getChildSelectedYear(state) {
            return state.childSelectedYear;
        },
        getChildRateEdit(state) {
            return state.childRateEdit;
        },
        getChildRateEditStatus(state) {
          return function(){
            return state.childRateEditStatus;
          }
        },
        getChildRateEditing(state) {
            return state.childRateEdit.id > 0;
        },
        getChildRateEditText(state) {
            return state.childRateEditText;
        },
        getChildRateditLoadStatus(state) {
            return state.childRateEditLoadStatus;
            
        },
        getChildrenLookupLoadStatus(state) {
            return state.childrenLookupLoadStatus;
        },
        getChildrenLookup(state) {
            return state.childrenLookup;
        },
        //logs
        getChildLogLoadStatus(state) {
            return state.childLogLoadStatus;
        },
        getChildLog(state) {
            return state.childLog;
        },
        getChildLogOptions(state){
            return state.childLogOptions;
        },
        //preseneces
        getChildPresenceLoadStatus(state) {
            return state.childPresenceLoadStatus;
        },
        getChildPresence(state) {
            return state.childPresence;
        },
        getChildPresenceOptions(state){
            return state.childPresenceOptions;
        },
        //settlements
        getChildSettlementsLoadStatus(state) {
            return state.childSettlementsLoadStatus;
        },
        getChildSettlements(state) {
            return state.childSettlements;
        },
        getChildSettlementsOptions(state){
            return state.childSettlementsOptions;
        },

        getChildrenShortCard(state){
            return state.childrenShortCard;
        }
    }
};
